<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <v-layout class="px-3" row wrap>
                <confirmation-header-text :text="$vuetify.lang.t('$vuetify.academic_institution')" class="ml-2"
                                          icon="mdi-school"></confirmation-header-text>

                <v-flex md3 xs6>
                    <list-item-detail
                        :sub_title="application_data.name_of_academic_institution"
                        :title="$vuetify.lang.t('$vuetify.name_of_academic_institution')"/>
                </v-flex>

                <v-flex md3 xs6>
                    <list-item-detail
                        :sub_title="application_data.subject"
                        :title="$vuetify.lang.t('$vuetify.subject')"/>
                </v-flex>

                <v-flex md3 xs6>
                    <list-item-detail
                        :sub_title="application_data.institute_address"
                        :title="$vuetify.lang.t('$vuetify.address_of_institution')"/>
                </v-flex>

            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        components: {
            ListItemDetail, ConfirmationHeaderText
        },
        computed: {
            application_data() {
                return this.$store.state.VisaSingle.visa.extra.application_data;
            },
        },

    };
</script>

<style>
</style>
